import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-po-menu',
  templateUrl: './po-menu.component.html',
  styleUrls: ['./po-menu.component.css']
})
export class PoMenuComponent implements OnInit {
    poKeyno;

    public menu?: Menu;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.poKeyno = this.stateService.getStateParams()['po_keyno'];
    }

    private async loadMenu() {
        if (!!this.poKeyno) {
            this.menu = (await this.datatask.Post(164, { po_keyno: this.poKeyno }))[0];
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    prod_id: string;
    prod_name: string;
    po_keyno: string;
    poh_keyno: string;
    show_button_tracing: string;
    quantity: string;
    quantity_finished: string;
    quantity_rest: string;
    quantity_finish_now: string;
    p2_pofinish_keyno: string;
    p2_pofinishprod_keyno: string;
    stock_keyno: string;
    labour_no: string;
    labour_name: string;
    show_setting: string;
    show_stock: string;
    always_show_pick_components: string;
    hide_finished_qty: string;
    show_add_po: string;
    product_edit: string;
    show_button_operations: string;
}
